{
  "headers": {
    "CamelAuthenticationFailurePolicyId": {
      "type": "java.lang.String"
    },
    "CamelAcceptContentType": {
      "type": "java.lang.String"
    },
    "CamelAggregatedSize": {
      "type": "java.lang.String"
    },
    "CamelAggregatedTimeout": {
      "type": "java.lang.String"
    },
    "CamelAggregatedCompletedBy": {
      "type": "java.lang.String"
    },
    "CamelAggregatedCorrelationKey": {
      "type": "java.lang.String"
    },
    "CamelAggregatedCollectionGuard": {
      "type": "java.lang.String"
    },
    "CamelAggregationStrategy": {
      "type": "java.lang.String"
    },
    "CamelAggregationCompleteCurrentGroup": {
      "type": "java.lang.String"
    },
    "CamelAggregationCompleteAllGroups": {
      "type": "java.lang.String"
    },
    "CamelAggregationCompleteAllGroupsInclusive": {
      "type": "java.lang.String"
    },
    "CamelAsyncWait": {
      "type": "java.lang.String"
    },
    "CamelBatchIndex": {
      "type": "java.lang.String"
    },
    "CamelBatchSize": {
      "type": "java.lang.String"
    },
    "CamelBatchComplete": {
      "type": "java.lang.String"
    },
    "CamelBeanMethodName": {
      "type": "java.lang.String"
    },
    "CamelBinding": {
      "type": "java.lang.String"
    },
    "breadcrumbId": {
      "type": "java.lang.String"
    },
    "CamelCharsetName": {
      "type": "java.lang.String"
    },
    "CamelCircuitBreakerState": {
      "type": "java.lang.String"
    },
    "CamelCreatedTimestamp": {
      "type": "java.lang.String"
    },
    "CamelClaimCheckRepository": {
      "type": "java.lang.String"
    },
    "Content-Encoding": {
      "type": "java.lang.String"
    },
    "Content-Length": {
      "type": "java.lang.String"
    },
    "Content-Type": {
      "type": "java.lang.String"
    },
    "CamelCookieHandler": {
      "type": "java.lang.String"
    },
    "CamelCorrelationId": {
      "type": "java.lang.String"
    },
    "CamelContentSchema": {
      "type": "java.lang.String"
    },
    "CamelContentSchemaType": {
      "type": "java.lang.String"
    },
    "CamelDataSetIndex": {
      "type": "java.lang.String"
    },
    "org.apache.camel.default.charset": {
      "type": "java.lang.String"
    },
    "CamelDestinationOverrideUrl": {
      "type": "java.lang.String"
    },
    "CamelDisableHttpStreamCache": {
      "type": "java.lang.String"
    },
    "CamelDuplicateMessage": {
      "type": "java.lang.String"
    },
    "CamelDocumentBuilderFactory": {
      "type": "java.lang.String"
    },
    "CamelExceptionCaught": {
      "type": "java.lang.String"
    },
    "CamelExceptionHandled": {
      "type": "java.lang.String"
    },
    "CamelEvaluateExpressionResult": {
      "type": "java.lang.String"
    },
    "CamelErrorHandlerBridge": {
      "type": "java.lang.String"
    },
    "CamelErrorHandlerCircuitDetected": {
      "type": "java.lang.String"
    },
    "CamelErrorHandlerHandled": {
      "type": "java.lang.String"
    },
    "CamelExternalRedelivered": {
      "type": "java.lang.String"
    },
    "CamelFailureHandled": {
      "type": "java.lang.String"
    },
    "CamelFailureEndpoint": {
      "type": "java.lang.String"
    },
    "CamelFailureRouteId": {
      "type": "java.lang.String"
    },
    "CamelFatalFallbackErrorHandler": {
      "type": "java.lang.String"
    },
    "CamelFileContentType": {
      "type": "java.lang.String"
    },
    "CamelFileLocalWorkPath": {
      "type": "java.lang.String"
    },
    "CamelFileName": {
      "type": "java.lang.String"
    },
    "CamelFileNameOnly": {
      "type": "java.lang.String"
    },
    "CamelFileNameProduced": {
      "type": "java.lang.String"
    },
    "CamelFileNameConsumed": {
      "type": "java.lang.String"
    },
    "CamelFilePath": {
      "type": "java.lang.String"
    },
    "CamelFileParent": {
      "type": "java.lang.String"
    },
    "CamelFileLastModified": {
      "type": "java.lang.String"
    },
    "CamelFileLength": {
      "type": "java.lang.String"
    },
    "CamelFileLockFileAcquired": {
      "type": "java.lang.String"
    },
    "CamelFileLockFileName": {
      "type": "java.lang.String"
    },
    "CamelFileLockExclusiveLock": {
      "type": "java.lang.String"
    },
    "CamelFileLockRandomAccessFile": {
      "type": "java.lang.String"
    },
    "CamelFileLockChannelFile": {
      "type": "java.lang.String"
    },
    "CamelFilterMatched": {
      "type": "java.lang.String"
    },
    "CamelFilterNonXmlChars": {
      "type": "java.lang.String"
    },
    "CamelGroupedExchange": {
      "type": "java.lang.String"
    },
    "CamelHttpScheme": {
      "type": "java.lang.String"
    },
    "CamelHttpHost": {
      "type": "java.lang.String"
    },
    "CamelHttpPort": {
      "type": "java.lang.String"
    },
    "CamelHttpBaseUri": {
      "type": "java.lang.String"
    },
    "CamelHttpCharacterEncoding": {
      "type": "java.lang.String"
    },
    "CamelHttpMethod": {
      "type": "java.lang.String"
    },
    "CamelHttpPath": {
      "type": "java.lang.String"
    },
    "CamelHttpProtocolVersion": {
      "type": "java.lang.String"
    },
    "CamelHttpQuery": {
      "type": "java.lang.String"
    },
    "CamelHttpRawQuery": {
      "type": "java.lang.String"
    },
    "CamelHttpResponseCode": {
      "type": "java.lang.String"
    },
    "CamelHttpResponseText": {
      "type": "java.lang.String"
    },
    "CamelHttpUri": {
      "type": "java.lang.String"
    },
    "CamelHttpUrl": {
      "type": "java.lang.String"
    },
    "CamelHttpChunked": {
      "type": "java.lang.String"
    },
    "CamelHttpServletRequest": {
      "type": "java.lang.String"
    },
    "CamelHttpServletResponse": {
      "type": "java.lang.String"
    },
    "CamelInterceptedEndpoint": {
      "type": "java.lang.String"
    },
    "CamelInterceptSendToEndpointWhenMatched": {
      "type": "java.lang.String"
    },
    "CamelInterrupted": {
      "type": "java.lang.String"
    },
    "CamelLanguageScript": {
      "type": "java.lang.String"
    },
    "CamelLogDebugBodyMaxChars": {
      "type": "java.lang.String"
    },
    "CamelLogDebugStreams": {
      "type": "java.lang.String"
    },
    "CamelLogEipName": {
      "type": "java.lang.String"
    },
    "CamelLoopIndex": {
      "type": "java.lang.String"
    },
    "CamelLoopSize": {
      "type": "java.lang.String"
    },
    "Long-Running-Action": {
      "type": "java.lang.String"
    },
    "CamelMaximumCachePoolSize": {
      "type": "java.lang.String"
    },
    "CamelMaximumEndpointCacheSize": {
      "type": "java.lang.String"
    },
    "CamelMaximumSimpleCacheSize": {
      "type": "java.lang.String"
    },
    "CamelMaximumTransformerCacheSize": {
      "type": "java.lang.String"
    },
    "CamelMaximumValidatorCacheSize": {
      "type": "java.lang.String"
    },
    "CamelMessageHistory": {
      "type": "java.lang.String"
    },
    "CamelMessageHistoryHeaderFormat": {
      "type": "java.lang.String"
    },
    "CamelMessageHistoryOutputFormat": {
      "type": "java.lang.String"
    },
    "CamelMessageTimestamp": {
      "type": "java.lang.String"
    },
    "CamelMulticastIndex": {
      "type": "java.lang.String"
    },
    "CamelMulticastComplete": {
      "type": "java.lang.String"
    },
    "CamelNotifyEvent": {
      "type": "java.lang.String"
    },
    "CamelOnCompletion": {
      "type": "java.lang.String"
    },
    "CamelOnCompletionRouteIds": {
      "type": "java.lang.String"
    },
    "CamelOffset": {
      "type": "java.lang.String"
    },
    "CamelOverruleFileName": {
      "type": "java.lang.String"
    },
    "CamelParentUnitOfWork": {
      "type": "java.lang.String"
    },
    "CamelStreamCacheUnitOfWork": {
      "type": "java.lang.String"
    },
    "CamelRecipientListEndpoint": {
      "type": "java.lang.String"
    },
    "CamelReceivedTimestamp": {
      "type": "java.lang.String"
    },
    "CamelRedelivered": {
      "type": "java.lang.String"
    },
    "CamelRedeliveryCounter": {
      "type": "java.lang.String"
    },
    "CamelRedeliveryMaxCounter": {
      "type": "java.lang.String"
    },
    "CamelRedeliveryExhausted": {
      "type": "java.lang.String"
    },
    "CamelRedeliveryDelay": {
      "type": "java.lang.String"
    },
    "CamelRestHttpUri": {
      "type": "java.lang.String"
    },
    "CamelRestHttpQuery": {
      "type": "java.lang.String"
    },
    "CamelRollbackOnly": {
      "type": "java.lang.String"
    },
    "CamelRollbackOnlyLast": {
      "type": "java.lang.String"
    },
    "CamelRouteStop": {
      "type": "java.lang.String"
    },
    "CamelReuseScripteEngine": {
      "type": "java.lang.String"
    },
    "CamelCompileScript": {
      "type": "java.lang.String"
    },
    "CamelSAXParserFactory": {
      "type": "java.lang.String"
    },
    "CamelSchedulerPolledMessages": {
      "type": "java.lang.String"
    },
    "CamelSoapAction": {
      "type": "java.lang.String"
    },
    "CamelSkipGzipEncoding": {
      "type": "java.lang.String"
    },
    "CamelSkipWwwFormUrlEncoding": {
      "type": "java.lang.String"
    },
    "CamelSlipEndpoint": {
      "type": "java.lang.String"
    },
    "CamelSlipProducer": {
      "type": "java.lang.String"
    },
    "CamelSplitIndex": {
      "type": "java.lang.String"
    },
    "CamelSplitComplete": {
      "type": "java.lang.String"
    },
    "CamelSplitSize": {
      "type": "java.lang.String"
    },
    "CamelStepId": {
      "type": "java.lang.String"
    },
    "CamelTimerCounter": {
      "type": "java.lang.String"
    },
    "CamelTimerFiredTime": {
      "type": "java.lang.String"
    },
    "CamelTimerName": {
      "type": "java.lang.String"
    },
    "CamelTimerPeriod": {
      "type": "java.lang.String"
    },
    "CamelTimerTime": {
      "type": "java.lang.String"
    },
    "CamelToEndpoint": {
      "type": "java.lang.String"
    },
    "CamelTraceEvent": {
      "type": "java.lang.String"
    },
    "CamelTraceEventNodeId": {
      "type": "java.lang.String"
    },
    "CamelTraceEventTimestamp": {
      "type": "java.lang.String"
    },
    "CamelTraceEventExchange": {
      "type": "java.lang.String"
    },
    "CamelTracingHeaderFormat": {
      "type": "java.lang.String"
    },
    "CamelTracingOutputFormat": {
      "type": "java.lang.String"
    },
    "CamelTransactionContextData": {
      "type": "java.lang.String"
    },
    "TryRouteBlock": {
      "type": "java.lang.String"
    },
    "Transfer-Encoding": {
      "type": "java.lang.String"
    },
    "CamelUnitOfWorkExhausted": {
      "type": "java.lang.String"
    },
    "CamelXsltFileName": {
      "type": "java.lang.String"
    },
    "CamelXsltError": {
      "type": "java.lang.String"
    },
    "CamelXsltFatalError": {
      "type": "java.lang.String"
    },
    "CamelXsltWarning": {
      "type": "java.lang.String"
    }
  }
}
